import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import { useNavigate } from 'react-router-dom';

function SSR() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>SmartSense&Rescue</BlockTitle>
          <BlockSubtitle>One of 21 Collaborative Initiatives from the Smart Data Economy Technology Program</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>This project was funded by the Federal Ministry for Economic Affairs and Energy (BMWE) and was a collaboration between the Technical University Berlin, the crisis prevention company Eurocommand and the emergency service of Cham (district in Bavaria). The main goal is the development of a software capable of detecting and tracking missing persons with optical and thermal cameras from drone perspective in order to support the rescue workers during their missions.</BlockText>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText><b>Project Start:</b> 01.05.2020</BlockText>
          <BlockText><b>Project End:</b> 30.04.2022</BlockText>
          <BlockText><b>Partners:</b> Eurocommand, Fire and Disaster Protection Office of the Cham District</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockSubtitle>Description</BlockSubtitle>
          <BlockText>Research on security to enhance the civilian safety of citizens and to support emergency personnel, such as the fire department, rescue, and medical services, etc., during emergencies and life-threatening situations, has significant societal benefits. Especially considering the enormous workload and overtime of emergency personnel due to increasing operations, rapid and efficient deployment is of utmost importance.
          <br/><br/>
          In such scenarios, knowledge about local conditions and information about the number and position of people and their movement is often crucial.
          <br/><br/>
          Especially when using deployment drones and helicopters in open terrain, current video-based technologies are not practical due to insufficient accuracy. Camera drones are currently used merely as an "extended eye" of the emergency personnel through purely visual evaluations and possess little to no additional intelligent functionalities.
          <br/><br/>
          There is a significant need for intelligent (smart) technologies that quickly and automatically assess the situation and thus efficiently support emergency forces for the efficient rescue or evacuation of people and risk minimization of emergency personnel from unnecessarily entering life-threatening situations.
          <br/><br/>
          The primary goal of this project is to develop intelligent methods for automatic people counting, person localization, and movement analysis using video recordings from commercial deployment drones (SmartSense) and to integrate them into existing operation management systems of authorities and organizations with security tasks (BOS) to support their emergency personnel in life-threatening situations simply and automatically (Rescue). Application scenarios for SmartSense&Rescue are diverse, ranging from searching for missing persons to severe disasters with complex damage situations, such as industrial and forest fires.
          <br/><br/>
          The Department of Communication Engineering at TUB will further develop already developed methods in this project in the areas of people counting, person localization, and movement analysis and prototypically integrate them into a complete system of the Eurocommand company.
          <br/><br/>
          The SmartSense&Rescue technologies are intended to be used in real application scenarios, which will be specified in the project by the fire department of the Cham district (LKC) and then evaluated.</BlockText>
        </BlockContent>
      </Block>

      {/* <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockSubtitle>Task Breakdown</BlockSubtitle>
          <BlockText>During the project, I spearheaded the development of a tracking procedure designed for the re-identification of individuals on a global situational map using extrinsic drone data. This method was enhanced by incorporating an advanced Kalman filter tracking with motion compensation, utilizing phase correlation techniques for image registration. A significant focus was also placed on refining and optimizing drone telemetry, and in instances of missing telemetry, it was generated through photogrammetry. Additionally, I crafted a GTK test environment written in Python, showcasing the results of drone captures on a UTM-based situational map. I also established an HTTP-based communication interface between the command center and the processing computer. To further illustrate the outcomes, I created simulated drone captures by animating and modifying existing 3D models of individuals. Apart from these tasks, I played a role in report documentation and supervised a master's thesis related to the project.</BlockText>
        </BlockContent>
      </Block> */}


      {/* <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://www.tu.berlin/nue/forschung/projekte/smartsenserescue')}>Projectpage</BlockButton>
        </BlockContent>
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Applications/SsrDemoTool')}>Demo</BlockButton>
        </BlockContent>
      </Block> */}
      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://www.tu.berlin/nue/forschung/projekte/smartsenserescue')}>Projectpage</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default SSR;